define('Components/PriceByShop/js/PriceByShop',['hooks'],function(hooks){
   return function(){
       hooks.registerHook('productHasContextualData',function(product,callback){
           if(product.get('priceByShop')){
               callback()
           }
       })
   } 
});
